import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormScreenHeader } from './FormScreenHeader';
import { InputField } from '@web/utils/src';
import { AddressValidationInput } from '@/components/AddressValidationInput';
import { IFormInput } from '../types';

interface AddressScreenProps {
  register: UseFormRegister<IFormInput>;
  errors: FieldErrors<IFormInput>;
  setValue: UseFormSetValue<IFormInput>;
  formValues: IFormInput;
  handleStageChange: (e: any, direction: 'next' | 'previous') => void;
  setCoordinates: (coordinates: { lat: number; long: number }) => void;
}

const AddressScreen: React.FC<AddressScreenProps> = ({
  register,
  errors,
  setValue,
  formValues,
  handleStageChange,
  setCoordinates,
}) => {
  const { t } = useTranslation();

  const setAddress = (name: string, value: string) => {
    setValue(name as keyof IFormInput, value);
  };

  return (
    <div role="addresses-screen">
      <FormScreenHeader
        title={t('create_user_modal.add_your_address')}
        handleStageChange={handleStageChange}
      />
      <AddressValidationInput
        setValue={setAddress}
        setCoordinates={setCoordinates}
      />
      <div className="mt-2-0 grid grid-cols-1 gap-2-0">
        <InputField
          register={register}
          errors={errors}
          name="addressLine1"
          required
          setValue={setValue}
          t={t}
        />
        <InputField
          register={register}
          errors={errors}
          name="addressLine2"
          setValue={setValue}
          t={t}
        />
        <InputField
          register={register}
          errors={errors}
          name="addressPostcode"
          required
          setValue={setValue}
          t={t}
        />
        <InputField
          register={register}
          errors={errors}
          name="addressLocality"
          required
          setValue={setValue}
          t={t}
        />
      </div>
    </div>
  );
};

export default AddressScreen;
